import { type FC, type ReactNode, useContext } from 'react'

import { Checkbox, FormHelperText } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

interface InputCheckBoxProps {
  children: ReactNode
  'data-qa-id': string
  field: 'tosAccepted' | 'newsletterAccepted'
}

export const LoginRegistrationInputCheckBox: FC<InputCheckBoxProps> = ({
  children,
  'data-qa-id': dataQaId,
  field,
}) => {
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )

  const { model } = registrationFormState
  const error = model.validator.getFirstErrorFor(field)

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Checkbox
          aria-labelledby="checkbox-label"
          checked={model[field]}
          data-qa-id={dataQaId}
          onChange={(event): void => {
            registrationFormState.setValue(event.target.checked, model, field)
          }}
          size="medium"
        />
        <div className="basis-11/12 pl-2 text-m" id="checkbox-label">
          {children}
        </div>
      </div>
      {error ? (
        <FormHelperText data-qa-id="salutation-error" error>
          {error}
        </FormHelperText>
      ) : null}
    </div>
  )
}
